"use client";

import { Star, Quote } from "lucide-react";
import Image from "next/image";
import dynamic from "next/dynamic";

const TestimonialSlider = dynamic(() => import("../sliders/TestimonialSlider"));

// const testimonials = [
//   {
//     name: "Priya & Arjun Sharma",
//     location: "Mumbai, India",
//     text: "Our stay at Kavish Jawai was magical. The leopard safari was breathtaking, and the service was impeccable. A perfect blend of luxury and wilderness. Every detail was thoughtfully curated, from the private dinners to the personalized safari experiences.",
//     rating: 5,
//     image:
//       "https://images.unsplash.com/photo-1766735325665-9e7dea46f9cc?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxyb21hbnRpYyUyMGNvdXBsZSUyMHJlc29ydHxlbnwxfHx8fDE3Njg5NzAyNTZ8MA&ixlib=rb-4.1.0&q=80&w=1080",
//   },
//   {
//     name: "Michael Thompson",
//     location: "London, United Kingdom",
//     text: "I've stayed at luxury resorts around the world, but Kavish Udaipur stands out. The attention to detail, the location, and the personalized service made it unforgettable. The lake views from my suite were absolutely stunning.",
//     rating: 5,
//     image:
//       "https://images.unsplash.com/photo-1622018135960-249abd263aeb?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHx1ZGFpcHVyJTIwbGFrZSUyMHBhbGFjZXxlbnwxfHx8fDE3Njg5Njk3NjB8MA&ixlib=rb-4.1.0&q=80&w=1080",
//   },
//   {
//     name: "Ananya Reddy",
//     location: "Bangalore, India",
//     text: "We celebrated our anniversary at Kavish Kumbhalgarh. The privacy, the views, and the romantic setup exceeded all expectations. Can't wait to return! The infinity pool overlooking the Aravalli hills was the perfect spot to unwind.",
//     rating: 5,
//     image:
//       "https://images.unsplash.com/photo-1562407132-e23789f81bb7?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxpbmZpbml0eSUyMHBvb2wlMjBtb3VudGFpbnN8ZW58MXx8fHwxNzY4OTcwMjU4fDA&ixlib=rb-4.1.0&q=80&w=1080",
//   },
// ];

export function TestimonialsSection({ lookUpCMSData, homeDetails }: any) {
  return (
    <section className="py-10 md:py-20 bg-white relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div
          className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `radial-gradient(circle at 1px 1px, #B42025 1px, transparent 0)`,
            backgroundSize: "40px 40px",
          }}
        />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {lookUpCMSData?.["Home - Section 6 : Guest Testimonials"] ? (
          <div
            dangerouslySetInnerHTML={{
              __html:
                lookUpCMSData?.[
                  "Home - Section 6 : Guest Testimonials"
                ]?.Template?.trim(),
            }}
          />
        ) : (
          <div className="text-center mb-20">
            <p className="text-[#B42025] tracking-[0.3em] mb-4 text-sm uppercase">
              Guest Testimonials
            </p>
            <h2 className="text-4xl md:text-6xl mb-6 text-[#1A1A1A]">
              Loved by Our Guests
            </h2>
            <p className="text-gray-600 text-xl mb-8 max-w-3xl mx-auto">
              The greatest stories of Kavish are told by those who stay with us.
            </p>

            <div className="inline-flex items-center gap-2 bg-[#F9F7F4] px-8 py-4 rounded-full">
              <div className="flex items-center gap-1">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 fill-[#C9A962] text-[#C9A962]"
                  />
                ))}
              </div>
              <div className="w-px h-6 bg-gray-300 mx-2" />
              <span className="text-gray-700">
                <span className="text-2xl text-[#B42025]">4.8</span>/5 Rating
              </span>
              <div className="w-px h-6 bg-gray-300 mx-2" />
              <span className="text-gray-600">1,200+ Reviews</span>
            </div>
          </div>
        )}

        <div className="relative">
          <TestimonialSlider data={homeDetails?.Testimonials || []} />
        </div>
        {false && (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {homeDetails?.Testimonials?.map(
              (testimonial: any, index: number) => (
                <div key={index} className="group relative">
                  {/* Background Image */}
                  <div className="absolute inset-0 rounded-2xl overflow-hidden">
                    <Image
                      src={testimonial?.TestimonialImage}
                      alt={testimonial?.CustomerName}
                      className="object-cover group-hover:scale-105 transition-transform duration-700"
                      fill
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/70 to-black/40" />
                  </div>

                  {/* Content */}
                  <div className="relative p-8 min-h-[500px] flex flex-col">
                    <Quote className="h-12 w-12 text-[#C9A962] mb-6" />

                    <div
                      suppressHydrationWarning={true}
                      className="text-white mb-8 leading-relaxed flex-grow"
                      dangerouslySetInnerHTML={{
                        __html: testimonial?.Description?.trim(),
                      }}
                    />

                    <div>
                      <div className="flex items-center gap-1 mb-4">
                        {[...Array(5)].map((_, i) => (
                          <Star
                            key={i}
                            className="h-4 w-4 fill-[#C9A962] text-[#C9A962]"
                          />
                        ))}
                      </div>
                      <div className="border-t border-white/20 pt-4">
                        <p className="text-white text-lg">
                          {testimonial?.CustomerName}
                        </p>
                        <p className="text-white/70 text-sm">
                          {testimonial?.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              ),
            )}
          </div>
        )}
      </div>
    </section>
  );
}
